import React, { useContext, useEffect, useState } from 'react';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { ThemeContext } from '../context/ThemeContext';
import { commonTheme } from "../theme";
import { getThemeObject } from "../Services/chatServices";
import { getSubdirectory } from '../utils/GetSubdirectory';
import { shouldFetchTheme } from '../utils/shouldFetchTheme';

const useTheme = () => {
    const subdirectory = getSubdirectory();
    const [loading, setLoading] = useState(false);
    const localthemeData = JSON.parse(localStorage.getItem(`${subdirectory}-themeData`)) || commonTheme
    const { mode } = useContext(ThemeContext);
    const [theme, setTheme] = useState({});
    const [themeData, setThemeData] = useState(localthemeData);


    useEffect(() => {
       
        if (shouldFetchTheme(subdirectory)) {
           
            localStorage.setItem(`${subdirectory}-themeFetched`, "false");
        }
    }, [subdirectory])

    //get theme from server

    useEffect(() => {
        const path = window.location.pathname.split("/")
        const subdirectory = path[1];
        const themeFetched = localStorage.getItem(`${subdirectory}-themeFetched`) === "true";

        if (themeFetched) return;
        const url = window.location.origin + path.slice(0, 2).join("/") + "/";
        setLoading(true);
        // Step 1: Remove the protocol part (http:// or https://)
        const withoutProtocol = url.replace(/^https?:\/\//, '');

        // Step 2: Remove non-alphanumeric characters (including . and /)
        const themeID = withoutProtocol.replace(/[^a-zA-Z0-9]/g, '');

        getThemeObject(themeID)
            .then((response) => {
                setLoading(false);
                const themeData = response.data;
                setThemeData(themeData);
                let appliedTheme = themeData[mode] || {};
                appliedTheme = {
                    ...appliedTheme,
                    typography: themeData.typography || {},
                    components: themeData.components || {},
                };
                localStorage.setItem(`${subdirectory}-themeData`, JSON.stringify(themeData));
                localStorage.setItem(`${subdirectory}-themeFetched`, "true");
                localStorage.setItem(`${subdirectory}-themeFetchedAt`, new Date().toISOString());
                setTheme(responsiveFontSizes(createTheme(appliedTheme)));
            })
            .catch((error) => {
                setLoading(false);

            });
    }, []);

    React.useMemo(
        () => {
            let appliedTheme = themeData[mode] || localthemeData[mode] || {};

            appliedTheme = {
                ...appliedTheme,
                typography: themeData.typography || {},
                components: themeData.components || {},
            };
            setTheme(responsiveFontSizes(createTheme(appliedTheme)));
        }, [themeData, mode]);

    return {
        theme,
        loading
    }
}

export default useTheme;